import RecruitJobPostings from "../components/Recruiting/RecruitJobPostings";
import {PERM} from "../utilites/permissions";

const recruitJobPostings = [
  {
    path: '/recruit_job_postings/:id(\\d+)?',
    name: 'RecruitJobPostings',
    component: RecruitJobPostings,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.RECRUIT_JOB_POSTING,
      ]
    }
  },
];

export default recruitJobPostings;



// WEBPACK FOOTER //
// ./src/router/recruitJobPostings.js